import React, { createContext, useState, useContext } from 'react';

// Create Context
const ActiveTabContext = createContext();

// Custom Hook to use the ActiveTab Context
export const useActiveTab = () => {
  return useContext(ActiveTabContext);
};

// ActiveTabProvider Component
export const ActiveTabProvider = ({ children }) => {
  const [activeTabX, setActiveTab] = useState({
    activeKey: localStorage.getItem("activeTabKey") || "1",
    innerActiveKey: null,
    personid: null,
  });

  return (
    <ActiveTabContext.Provider value={{ activeTabX, setActiveTab }}>
      {children}
    </ActiveTabContext.Provider>
  );
};
